import React, { useState } from 'react'
import './feature-detail-content.scss'
import OptionLayout from '../OptionLayout';
import { useTranslation } from 'react-i18next';
import { recordingEntitties } from '../../constant';
import { useParams } from 'react-router-dom';

const FeatureDetail = () => {
	const { id } = useParams();
	const feature = recordingEntitties.find((featrue) => featrue.key === id)
	const [entities, setEntities] = useState(feature.entities);
	const [selectedEntities, setSelectedEntities] = useState([]);
	const { t } = useTranslation();

	const handleSelection = (defaultSelected, selectedValue) => {

		let settings = [...entities];

		settings.forEach((s) => {
			s?.entities?.forEach((record) => {
				if (defaultSelected && defaultSelected.includes(record.id)) {
					record.isSelected = selectedValue;
				}

				if (record.counter_dependency && record.counter_dependency.length > 0) {
					record.counter_dependency.forEach((counterDepId) => {
						const counterDependentRecord = settings
							.flatMap((s) => s?.entities || [])
							.find((r) => r.id === counterDepId);

						if (counterDependentRecord) {
							if (!defaultSelected.includes(counterDependentRecord.id)) {
								counterDependentRecord.isSelected = false;
							}
						}
					});
				}
			});
		});

		setEntities(settings);

		setSelectedEntities(getSelectedEntries(settings));
	};

	const getSelectedEntries = (settings) => {
		let selectedEntries = [];

		settings?.forEach((s) => {
			s?.entities?.forEach((record) => {
				if (record.isSelected) {
					selectedEntries.push(record);
				}
			});
		});

		return selectedEntries;
	};

	return (
		<div className='features-containers'>
			<h1>{t(feature.name)}</h1>
			<p>{t(feature.description)}</p>

			<h2>{t(feature.overview.name)}</h2>
			<p>{t(feature.overview.description)}</p>

			<div className={'instructor-profile-container'}>
				{
					<div
						className={'instructor-option-container'}
					>
						<div
							className={'option-container-header'}
						>
						</div>
						{
							<div className={'ml-3'}>
								<div className={'layout-container'}>
									{
										feature?.entities?.map((value, index) => (
											<OptionLayout
												key={index}
												title={t(value.key)}
												imageSource={value.image}
												record={value}
												handleSelection={handleSelection}
											/>
										))
									}
								</div>
							</div>
						}
					</div>
				}
			</div>

			{
				feature.entityDescription.map((desc, index) => (
					<div key={index}>
						<h2>{t(desc.heading)}</h2>
						<p>{t(desc.description)}</p>
					</div>
				))
			}
		</div>
	)
}

export default FeatureDetail;